import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { SalesCycle } from '../../../core/workspace/workspace';
import { WorkspaceHolderService } from '../../../core/workspace/workspace.holder.service';

@Component({
  selector: 'app-sales-cycle-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzTagModule],
  templateUrl: './sales-cycle-bar.component.html',
  styleUrl: './sales-cycle-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalesCycleBarComponent {
  constructor(private workspaceHolderService: WorkspaceHolderService) {}

  @Input() changeCurrentSalesCycle = true;
  @Output() salesCycleChange = new EventEmitter<SalesCycle>();

  selectableSalesCycleList = computed(() => {
    const workspace = this.workspaceHolderService.currentWorkspace();
    const list = workspace.settings?.salesCycleList?.map((salesCycle) => {
      return {
        isSelected: false,
        value: salesCycle,
      };
    });

    if (!this.changeCurrentSalesCycle) {
      if (list && list.length > 0) {
        list[0].isSelected = true;
      }
    }

    return list;
  });

  isShowAll = true;

  onShowAllClick() {
    if (this.changeCurrentSalesCycle) {
      this.workspaceHolderService.currentSalesCycle.set(undefined);
      this.isShowAll = true;

      for (const element of this.selectableSalesCycleList() ?? []) {
        element.isSelected = false;
      }

      this.workspaceHolderService.currentSalesCycle.set(undefined);
    }

    this.salesCycleChange.emit(undefined);
  }

  onSalesCycleClick(selectableSalesCycle: { isSelected: boolean; value: any }) {
    this.isShowAll = false;
    this.selectableSalesCycleList()?.forEach((c) => (c.isSelected = false));

    selectableSalesCycle.isSelected = true;

    if (this.changeCurrentSalesCycle) {
      this.workspaceHolderService.currentSalesCycle.set(selectableSalesCycle.value);
    }

    this.salesCycleChange.emit(selectableSalesCycle.value);
  }
}
